import React from "react";
import "../../Styles/Profile.css";
import { baseURL } from "../../services/axios/eps";
import { format } from "date-fns";
import { Badge } from "react-bootstrap";

const GameDetailsView = ({ gameData }) => {
  return (
    <>
      <div className="tab-pane active mb-3" id="basicDetails" role="tabpanel">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-header bg-dark text-white py-3">
            <h5 className="card-title mb-0 fs-4 fw-bold">Game Information</h5>
          </div>
          <div className="card-body bg-dark text-white">
            <div className="row g-4">
              {[
                {
                  label: "Game Name",
                  value: gameData?.title || "",
                },
                {
                  label: "Game Slug",
                  value: gameData?.slug || "",
                },
                {
                  label: "Company Name",
                  value: gameData?.company || "",
                },
                {
                  label: "Published By",
                  value: gameData?.published_by || "",
                },
                {
                  label: "Provider Name",
                  value: gameData?.provider?.name || "",
                },
                {
                  label: "Status",
                  value: gameData?.status ? "Active" : "In Active",
                },
                {
                  label: "Dimensions",
                  value: gameData?.dimensions || "",
                },
                {
                  label: "Category",
                  value: gameData?.game_category?.name || "",
                },
                {
                  label: "Sub-Category",
                  value: gameData?.game_sub_category?.name || "",
                },
                {
                  label: "Orientation",
                  value: gameData?.orientation || "",
                },
                {
                  label: "Language",
                  value: gameData?.language || "",
                },
                {
                  label: "Mobile Web compatible",
                  value: gameData?.mob_web_compatible ? "Yes" : "No",
                },
                {
                  label: "Recommended",
                  value: gameData?.recommended ? "Yes" : "No",
                },
                {
                  label: "Featured",
                  value: gameData?.featured ? "Yes" : "No",
                },

                {
                  label: "Published Date",
                  value: gameData?.published_date
                    ? format(gameData.published_date, "PP")
                    : "",
                },
                {
                  label: "Last Update",
                  value: gameData?.last_update
                    ? format(gameData.last_update, "PP")
                    : "",
                },
              ].map((item, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                    <span className="text-secondary fs-6 fw-semibold">
                      {item.label}
                    </span>
                    <span
                      className={`d-block fs-5 fw-medium ${!item?.value && "text-danger"}`}
                    >
                      {item.value || "N/A"}
                    </span>
                  </div>
                </div>
              ))}
              <div className="col-lg-6">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">
                    Gender
                  </span>
                  <div>
                    {gameData?.gender?.map((m) => (
                      <Badge key={m} bg="secondary" className="mr-2 p-2">
                        <p className="fs-6 mb-0">{m}</p>
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">
                    Age Group
                  </span>
                  <div>
                    {gameData?.age_group?.map((m) => (
                      <Badge key={m} bg="secondary" className="mr-2 p-2">
                        <p className="fs-6 mb-0">{m}</p>
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">Tags</span>
                  <div>
                    {gameData?.tags?.map((m) => (
                      <Badge key={m} bg="secondary" className="mr-2 p-2">
                        <p className="fs-6 mb-0">{m}</p>
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
              {[
                {
                  label: "Description",
                  value: gameData?.description || "",
                },
                {
                  label: "Instructions",
                  value: gameData?.instructions || "",
                },
              ].map((item, index) => (
                <div className="col-lg-12" key={index}>
                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                    <span className="text-secondary fs-6 fw-semibold">
                      {item.label}
                    </span>
                    <p className={`fs-5 mb-0 ${!item?.value && "text-danger"}`}>
                      {item.value || "N/A"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="tab-pane" id="companyInfo" role="tabpanel">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-header bg-dark text-white py-3">
            <h5 className="card-title mb-0 fs-4 fw-bold">
              Game Provider Information
            </h5>
          </div>
          <div className="d-flex justify-content-center bg-dark">
            {gameData?.provider?.logo && (
              <img
                crossOrigin="anonymous"
                src={`${baseURL}/uploads/file/${gameData.provider.logo}`}
                alt="Logo"
                className="img-fluid rounded center"
                style={{
                  maxHeight: "200px",
                  objectFit: "contain",
                }}
              />
            )}
          </div>
          <div className="card-body bg-dark text-white">
            <div className="row g-4">
              {[
                {
                  label: "Provider Name",
                  value: gameData?.provider?.name || "",
                },
                {
                  label: "Contact Email",
                  value: gameData?.provider?.contact_email || "",
                },
                {
                  label: "Website",
                  value: gameData?.provider?.website || "",
                },
                {
                  label: "Phone",
                  value: gameData?.provider?.phone || "",
                },
                {
                  label: "Logo",
                  value: gameData?.provider?.logo || "",
                },
                {
                  label: "Created At",
                  value: gameData?.provider?.createdAt
                    ? format(gameData.provider.createdAt, "PP")
                    : "",
                },
                {
                  label: "Updated At",
                  value: gameData?.provider?.updatedAt
                    ? format(gameData.provider.updatedAt, "PP")
                    : "",
                },
              ].map((item, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                    <span className="text-secondary fs-6 fw-semibold">
                      {item.label}
                    </span>
                    <span
                      className={`d-block fs-5 fw-medium ${!item?.value && "text-danger"}`}
                    >
                      {item.value || "N/A"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="tab-pane text-light" id="securityPrivacy" role="tabpanel">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-header bg-dark text-white">
            {/* Card Header */}
            <div className="card-header bg-dark text-white py-3 border-bottom border-secondary">
              <h5 className="card-title mb-0 fw-bold">Settings</h5>
            </div>

            <div className="card-body">
              <div className="row">
                {[
                  {
                    label: "Created At",
                    value:
                      (gameData?.createdAt &&
                        format(gameData.createdAt, "PP")) ||
                      "",
                  },
                  {
                    label: "Updated At",
                    value:
                      (gameData?.updatedAt &&
                        format(gameData.updatedAt, "PP")) ||
                      "",
                  },
                  {
                    label: "Created By",
                    value: `${gameData?.game_created_by?.first_name || ""} ${gameData?.game_created_by?.last_name || ""}`,
                  },
                  {
                    label: "Updated By",
                    value: `${gameData?.game_updated_by?.first_name || ""} ${gameData?.game_updated_by?.last_name || ""}`,
                  },
                  {
                    label: "Deleted At",
                    value: gameData?.deletedAt || "",
                  },
                ].map((item, index) => (
                  <div className="col-lg-6 mb-3" key={index}>
                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                      <span className="text-secondary fs-6 fw-semibold">
                        {item.label}
                      </span>
                      <span
                        className={`d-block fs-5 fw-medium ${!item?.value && "text-danger"}`}
                      >
                        {item.value || "N/A"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GameDetailsView;
